export default __webpack_public_path__ + "static/media/smartmockups-kkfuvl3l-911x659.d0c445ef.png";